/**
 * Hulara wishlist — localStorage, no app required.
 * Storage key: hulara_wishlist (array of product objects)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hulara_wishlist';
  var migrating = false;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function readRaw() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function readList() {
    var parsed = readRaw();
    if (!Array.isArray(parsed)) return [];

    var objects = parsed.filter(function (item) {
      return item && typeof item === 'object' && item.id;
    });
    if (objects.length) return objects;

    var legacyIds = parsed
      .filter(function (item) {
        return typeof item === 'string' || typeof item === 'number';
      })
      .map(String);

    if (legacyIds.length && !migrating) {
      migrateLegacyIds(legacyIds);
    }

    return [];
  }

  function migrateLegacyIds(ids) {
    migrating = true;
    Promise.all(
      ids.map(function (id) {
        return fetch('/search.json?q=id:' + encodeURIComponent(id) + '&type=product')
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var p = data.results && data.results[0];
            if (!p) return null;
            return {
              id: String(p.id),
              handle: p.handle || '',
              title: p.title || '',
              url: p.url || '/products/' + p.handle,
              image: p.featured_image || p.image || '',
              price: p.price ? formatMoney(p.price) : ''
            };
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (items) {
      migrating = false;
      var list = items.filter(Boolean);
      if (list.length) {
        writeList(list);
      }
    });
  }

  function writeList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(
      new CustomEvent('hulara:wishlist-updated', { detail: { count: list.length } })
    );
    if (typeof window.HularaWishlist.renderPage === 'function') {
      window.HularaWishlist.renderPage();
    }
  }

  function normalizeItem(data) {
    if (!data || !data.id) return null;
    return {
      id: String(data.id),
      handle: data.handle || '',
      title: data.title || '',
      url: data.url || (data.handle ? '/products/' + data.handle : ''),
      image: data.image || '',
      price: data.price || ''
    };
  }

  function isSaved(productId) {
    var id = String(productId);
    return readList().some(function (item) {
      return String(item.id) === id;
    });
  }

  function toggle(itemData) {
    var item = normalizeItem(itemData);
    if (!item) return false;
    var list = readList();
    var idx = list.findIndex(function (i) {
      return String(i.id) === item.id;
    });
    if (idx >= 0) {
      list.splice(idx, 1);
      writeList(list);
      return false;
    }
    list.push(item);
    writeList(list);
    return true;
  }

  function remove(productId) {
    var id = String(productId);
    var list = readList().filter(function (i) {
      return String(i.id) !== id;
    });
    writeList(list);
  }

  function getAll() {
    return readList();
  }

  function syncButton(btn) {
    if (!btn || !btn.dataset.productId) return;
    var pressed = isSaved(btn.dataset.productId);
    btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    btn.classList.toggle('is-wishlisted', pressed);
  }

  function initButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      syncButton(btn);
      if (btn.dataset.wishlistBound === 'true') return;
      btn.dataset.wishlistBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var saved = toggle({
          id: btn.dataset.productId,
          handle: btn.dataset.productHandle,
          title: btn.dataset.productTitle,
          url: btn.dataset.productUrl,
          image: btn.dataset.productImage,
          price: btn.dataset.productPrice
        });
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        btn.classList.toggle('is-wishlisted', saved);
      });
    });
  }

  function updateHeaderCount() {
    var count = readList().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
      el.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
    });
  }

  window.HularaWishlist = {
    getAll: getAll,
    toggle: toggle,
    remove: remove,
    isSaved: isSaved,
    initButtons: initButtons,
    updateHeaderCount: updateHeaderCount,
    renderPage: function () {}
  };

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    updateHeaderCount();
    readList();
  });

  document.addEventListener('hulara:wishlist-updated', updateHeaderCount);
})();
